import React, { forwardRef, useState  } from "react";
import DatePicker , { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import BlockIcon from "@mui/icons-material/Block";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import "./index.scss";

registerLocale("fr", fr); 

const CustomizedInput = forwardRef(({ value, onClick, onChange, onClear, disabled, enableClearButton, showWarning }, ref) => (
    <TextField
        inputRef={ref}
        value={value}
        onClick={onClick}
        onChange={onChange}
        disabled={disabled}
        // placeholder="Select date"
        className={"customized-date-picker" + (showWarning ? " warning" : "")}
        slotProps={{
            input: {
                endAdornment: value ? (
                    <InputAdornment position="end">
                        <IconButton 
                            onClick={(e) => {
                                enableClearButton && e.stopPropagation();
                                onClear?.();
                            }} 
                            edge="end" 
                            disabled={disabled}>
                            { disabled ? <BlockIcon/> : (enableClearButton ? <ClearIcon/> : <CalendarMonthIcon/>)}
                        </IconButton>
                    </InputAdornment>
                ) : null
            }
        }}
    />
));



const CustomizedDatePicker = (props) => {
   
    const handleDateClear = () => {
        props.handleDateChange?.(null);
    };

    const handleDateChange = (date) => {
        props.handleDateChange?.(date);
    };

    const { languageCode, minDate, maxDate, value, isDisabled, enableClearButton, showWarning = false } = props;

    const datePickerProps = {
        dateFormat: "dd MMM yyyy",
        disabled: isDisabled,
        minDate,
        maxDate,
        selected: value ? new Date(value) : null,
        onChange: handleDateChange,
        locale: languageCode?.toLowerCase() === "fr" ? "fr" : undefined,
        customInput: (
            <CustomizedInput
                disabled={isDisabled}
                showWarning={showWarning}
                enableClearButton={enableClearButton}
                onClear={enableClearButton ? handleDateClear : undefined}
            />
        )
    };

    return (
        <div className="row">
            <DatePicker {...datePickerProps} />
        </div>
    );
};

export default React.memo(CustomizedDatePicker);